import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchTeams() {
  const { data } = await api.get("/teams");
  return data.teams;
}

export async function fetchMatch(id) {
  const { data } = await api.get(`/matches/${id}`);
  return data;
}

export async function fetchHistory() {
  const { data } = await api.get("/matches?limit=40");
  return data.matches;
}

export async function fetchBracketSeed() {
  const { data } = await api.post("/bracket/seed");
  return data;
}

export async function runTournament(seed) {
  const { data } = await api.post("/tournament/run", seed ? { seed } : {});
  return data;
}

export async function fetchLineup(code) {
  const { data } = await api.get(`/teams/${code}/lineup`);
  return data;
}

export function ogCardUrl(matchId) {
  return `${API}/matches/${matchId}/og.png`;
}

export async function simulateNow({ teamA, teamB, knockout = false }) {
  const { data } = await api.post("/simulate", {
    team_a: teamA,
    team_b: teamB,
    knockout,
  });
  return data;
}

/**
 * Stream a simulation via SSE.
 * onEvent(parsedJsonPayload) — called per data: line.
 * Returns an AbortController to allow cancellation.
 */
export function streamSimulation({ teamA, teamB, knockout = false }, onEvent) {
  const controller = new AbortController();
  (async () => {
    try {
      const res = await fetch(`${API}/simulate/stream`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ team_a: teamA, team_b: teamB, knockout }),
        signal: controller.signal,
      });
      if (!res.body) return;
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n\n");
        buffer = lines.pop() || "";
        for (const block of lines) {
          const line = block.split("\n").find((l) => l.startsWith("data: "));
          if (!line) continue;
          try {
            const json = JSON.parse(line.slice(6));
            onEvent(json);
          } catch (e) {
            console.warn("SSE parse error, skipping line:", e);
          }
        }
      }
    } catch (e) {
      if (e.name !== "AbortError") {
        onEvent({ type: "error", message: e.message });
      }
    }
  })();
  return controller;
}
